import { render, staticRenderFns } from "./EventTeamsResume.vue?vue&type=template&id=6fdc87ca&scoped=true"
import script from "./EventTeamsResume.vue?vue&type=script&lang=js"
export * from "./EventTeamsResume.vue?vue&type=script&lang=js"
import style0 from "./EventTeamsResume.vue?vue&type=style&index=0&id=6fdc87ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc87ca",
  null
  
)

export default component.exports